export * from './lib/badge.module';
